export default class Item {
  constructor(args = {}) {
    this.store = args.store;
    this.info = args.tagInfo;
  }

  render() {
    let description;
    if (this.info.description) {
      description = `<p class="mb-3">${this.info.description}</p>`;
    } else {
      description = '';
    }
    return `
      <div class="col-12 col-lg-4 mb-4">
        <div class="card">
          <div class="embed-responsive embed-responsive-16by9">
          <img class="embed-responsive-item object-fit-cover-cc" src="${this.info.picPath || this.store.view.noImagePath}" />
          </div>
          <div class="card-body">
            <div class="badge badge-outline-dark mx-1px mb-3">
              ${this.info.area}
            </div>
            <div class="mb-1">
              <a class="item__name h5" href="${this.info.permalink}" target="_blank">
                ${this.info.name}
              </a>
            </div>
            <div class="mb-3 small">
              ${this.info.address}
            </div>
              ${description}
            </p>
            <div class="mb-3 small">
              評価：${this.info.rating || '---'}
            </div>
            <a class="btn btn-secondary" href="${this.info.permalink}" target="_blank">
              <span class="position-relative">
                <span class="pr-3 pr-lg-5">もっと見る</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" class="svg-inline--fa btn-icon btn-icon-pos-r btn-icon-hvr-l-to-r-anim"><!-- Font Awesome Free 5.15.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"></path></svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    `;
  }
}
